module.exports = __webpack_public_path__ + "img/ni.13e80ee9.svg";